// @flow
import type { Untranslated } from '@rover/shared/js/types';

export const isTranslatable = (obj: any) =>
  obj && (typeof obj === 'string' || typeof obj.id === 'string');

export const toUntranslated = (message: string): Untranslated => ({ id: message });

/**
 * The intended usage of this function is inside unit tests or other places
 * where the string value does not matter (e.g.  as a `key` in React components).
 * In places where the value of the string does matter use `i18n._`
 * https://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/737181906/Frontend+string+translation#Frontendstringtranslation-React:translatecomponentattributes:
 *
 */
export const untranslatedToString = (obj: ?Untranslated): ?string =>
  obj && typeof obj === 'object' ? obj.id : obj;



// WEBPACK FOOTER //
// ../utilities/i18n.js